<template>
	<div id="line"></div>
</template>

<script>
	import echarts from 'echarts';

	export default {
		mounted() {
      const colors = ['#5793f3', '#d14a61', '#675bba'];
      const myChart = echarts.init(document.getElementById('line'));
      myChart.setOption({
        color: colors,
        grid: {
          left: 60,
          top: 10,
	        bottom: 30
        },
        tooltip: {
          trigger: 'axis'
        },
        xAxis: {
          data: ['1号', '2号', '3号', '4号', '5号', '6号', '7号', '8号', '9号', '10号']
        },
        yAxis: {},
        series: [{
          name: '数据',
          type: 'line',
          data: [1120, 1300, 900, 888, 999, 1560, 999, 999, 999, 999]
        }]
      });
		},
	}
</script>

<style lang="less" scoped>

	#line {
		width: 375px;
		height: 160px;
	}
</style>
